import {
  BarChartData,
  BarGroupData,
  BarChartLegend
} from '../../shared/models/charts/chart-data-types';
import {
  colorizeTrancheGroups,
  setValuesOnLegends,
  setSelectionsOnLegends,
  sortTrancheGroups,
  trancheGroupsToBarGroups
} from '../../tranche/mappers/tranche.mapper';
import { IssueOrderPeriod } from '@ipreo/muni-shared';
import {
  getColorPartExtractor,
  getLegendExtractor,
  ColorPartExtractor
} from '../mappers/gameDay.extractors';
import { TrancheGroup } from '../data/gameDay-data.transformations';
import { DealWithTrancheOrders } from '../../state/types';
import { GamedayState } from '../../state/data/state';
import { ProgressBarChartState } from '../../state/charts/state';
import { GameDayModel } from '../../models/gameday-model';

export function getChartData({
  data: {
    deal,
    orders,
    filters: { viewType, legendCategories }
  },
  charts: { combinedTranchesIds, hoveredOrder, selectedTrancheId },
  tranches: {
    searched: { trancheGroups }
  }
}: {
  data: GamedayState;
  charts: ProgressBarChartState;
  tranches: {
    filtered: DealWithTrancheOrders;
    searched: DealWithTrancheOrders;
  };
}): BarChartData {
  const highlightedTrancheGroup: TrancheGroup = findTrancheGroupByMaturity(
    trancheGroups,
    hoveredOrder && hoveredOrder.maturity
  );
  const highlightedTrancheId: string = highlightedTrancheGroup
    ? highlightedTrancheGroup.id
    : undefined;

  const legend: BarChartLegend[] = getLegendExtractor(viewType)(
    deal,
    orders.slice()
  );
  const colorPartExtractor: ColorPartExtractor = getColorPartExtractor(legend);
  const { isOpen } = IssueOrderPeriod.orderPeriodIsOpen(deal);

  setValuesOnLegends(legend, trancheGroups);
  setSelectionsOnLegends(legend, legendCategories);
  colorizeTrancheGroups(trancheGroups, colorPartExtractor);
  sortTrancheGroups(trancheGroups, legend);

  const groups: BarGroupData[] = trancheGroupsToBarGroups(
    trancheGroups,
    selectedTrancheId,
    combinedTranchesIds,
    highlightedTrancheId,
    isOpen
  );

  groups.forEach(group => {
    if (group.id === selectedTrancheId) {
      group.bottomLabel = [group.bottomLabel[0]];
    }

    group.bars.forEach(bar => {
      if (bar.id === selectedTrancheId) {
        group.bottomLabel = [group.bottomLabel[0]];
      }
    });
  });

  return { groups, legend };
}

export function findTrancheGroupByMaturity(
  trancheGroups: TrancheGroup[],
  maturity: GameDayModel.Maturity | undefined
): TrancheGroup | undefined {
  if (!maturity) {
    return undefined;
  }
  return trancheGroups.find(group =>
    group.maturities.some(m => m.id === maturity.id)
  );
}
